import React from 'react';

const LogoBox = ({ children }) => (
  <div className="h-16 px-6 bg-white rounded-xl shadow-sm border border-black/5 flex items-center justify-center min-w-[140px] hover:shadow-md transition-shadow">
    {children}
  </div>
);

// Self-hosted assets in /app/frontend/public/logos/
const partnerLogos = [
  { name: 'Amazon',   src: '/logos/amazon.svg' },
  { name: 'Flipkart', src: '/logos/flipkart.svg' },
  { name: 'Meesho',   src: '/logos/meesho.svg' },
  { name: 'Myntra',   src: '/logos/myntra.svg' },
  { name: 'JioMart',  src: '/logos/jiomart.svg' },
];

const customerLogos = [
  { name: 'Customer 1', src: '/logos/customer1.svg' },
  { name: 'Customer 2', src: '/logos/customer2.svg' },
  { name: 'Customer 3', src: '/logos/customer3.svg' },
  { name: 'Customer 4', src: '/logos/customer4.svg' },
  { name: 'Customer 5', src: '/logos/customer5.svg' },
];

const PartnersAndCustomers = () => (
  <section className="bg-[#FAF2E8] py-14 relative" data-testid="partners-customers">
    <div className="absolute left-6 top-6 grid grid-cols-6 gap-1.5 opacity-50 pointer-events-none">
      {Array.from({ length: 30 }).map((_, i) => (
        <span key={i} className="w-1 h-1 rounded-full bg-[#F39200]/40" />
      ))}
    </div>

    <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-10 lg:gap-16">
      <div>
        <h3 className="text-xl md:text-2xl text-neutral-900">
          We&apos;ve networked with <span className="font-extrabold text-[#F39200]">15+ commerce partners</span>
        </h3>
        <div className="mt-6 flex flex-wrap gap-4">
          {partnerLogos.map((p) => (
            <LogoBox key={p.name}>
              <img src={p.src} alt={p.name} className="h-8 max-w-[120px] object-contain" loading="lazy" />
            </LogoBox>
          ))}
        </div>
      </div>

      <div className="lg:border-l lg:border-black/10 lg:pl-16">
        <h3 className="text-xl md:text-2xl text-neutral-900">
          Trusted and used by <span className="font-extrabold text-[#F39200]">28,000+ customers</span>
        </h3>
        <div className="mt-6 flex flex-wrap gap-4">
          {customerLogos.map((c) => (
            <LogoBox key={c.name}>
              <img src={c.src} alt={c.name} className="h-8 max-w-[120px] object-contain" loading="lazy" />
            </LogoBox>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default PartnersAndCustomers;
